import seedrandom from 'seedrandom';

import { getDeviceId } from './device';

/**
 * Gets a random number based on a seed
 *
 * @param {String} [seed=`device based seed`] The seed to be used
 * @returns A random number between 0 and 1
 */
const getRandom = (seed = getDeviceId()) => seedrandom(seed)();

/**
 * Gets a random option out of an array of weighted options. The array is expected to contain pairs
 * of [option, weight].
 *
 * @param {Array} options List of options. Each option is a pair of [key, weight].
 * @param {String} [seed] Optional seed
 * @returns Thekey of the choosen option
 */
const getWeightedRandomOption = (options = [], seed) => {
  if (options.length === 0) return null;
  const sumOfOptionsWeight = options.reduce((total, [, weight]) => total + weight, 0);
  let random = getRandom(seed);
  for (let i = 0; i < options.length; i++) {
    const [optionKey, optionWeight] = options[i];
    const normalizedOptionWeight = (optionWeight / sumOfOptionsWeight);
    if (random <= normalizedOptionWeight) {
      return optionKey;
    }
    random -= normalizedOptionWeight;
  }
  return null;
};

/**
 * Returns a seed based on device+ provided flag
 *
 * @param {string} flag The flag
 * @returns A string with the seed
 */
const getDeviceBasedSeed = (flag) => `${flag}|${getDeviceId()}`;

export {
  getRandom,
  getWeightedRandomOption,
  getDeviceBasedSeed,
};
